import PostApiBase from "@/modules/post/services/ApiBase"

export default class Api {
    static users() {
        return PostApiBase.users().then((resp) => {
            return resp.data["items"]
        })
    }
}
